/** @jsxRuntime classic */
/** @jsx jsx */
import React, { useCallback, useEffect, useRef, useState } from 'react'
import { jsx } from "@emotion/core";
import { Cancel, ChatGPTErrorIcon, ChatGPTIcon, ChatIcon2, ChatUserIcon, CopyActiveIcon, CopyIcon, EditIcon2, MaximizeIcon, MessageIcon, ReloadIcon2, Tick, Trash } from '../LandingHeader/Feedback/icons/Icons';
import './style.css';
import {deleteConversation, getChatTitle, saveConversation, sendPrompt1} from '../action/chatGPT';
import _ from 'lodash';
import { useDispatch } from 'react-redux';
import { clearChat, setChat, setCurrentPersona, setCurrentPrompt } from '../../redux/slices/AiAssistant';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { CHATGPT } from '../common/constants';
import {resetTasks} from '../../redux/slices/AiTasks';
import moment from 'moment';
import 'katex/dist/katex.min.css' // `rehype-katex` does not import the CSS for you
import { usePosthog } from '../../PosthogProvider';
import Ajv from "ajv";
import TodoList from './TodoList';
import PromptInputBox from './PromptInputBox';
import CompletionContent from './CompletionContent';
import PlannedTasks from '../../pages/HomePage/Rituals/PlannedTasks';
const todoSchema = {
    type: "array",
    items: {
      type: "object",
      properties: {
        title: { type: "string" },
        description: { type: "string" },
        dueDate: { type: "string" },
        priority: { type: "string" },
      },
      required: ["title", "description"],
      additionalProperties: false,
    },
    minItems: 1,
};

const validateTodoData = (data) => {
    const ajv = new Ajv();
    const validate = ajv.compile(todoSchema);

    const isValid = validate(data);

    if (!isValid) {
      return false;
    } else {
      return true;
    }
};

const Chat = ({fullscreen = false, cancelHandler, fullscreenButton = true, chatType = null}) => {
    const promptInputRef = useRef('');
    const titleInput = useRef('');
    const chatTitleRef = useRef('');
    const promptInputWrapperRef = useRef('');
    const [focus, setFocus] = useState(true);
    const [copyMessageId, setCopyMessageId] = useState(null);
    const id = useSelector(state =>  state.aiAssistant.id);
    const chatData = useSelector(state =>  state.aiAssistant.chatData);
    const persona = useSelector(state =>  state.aiAssistant.persona);
    const title = useSelector(state =>  state.aiAssistant.title);
    const taskList = useSelector(state =>  state.aiAssistant.taskList);
    const [completions, setCompletions] = useState(chatData.length > 0 ? chatData : []);
    const [progress, setProgress] = useState(false);
    const chatContainerRef = useRef('');
    const personaRef = useRef('');
    const theme = useSelector(state => state.theme.theme)
    const [personaSelection, setPersonaSelection] = useState(null);
    const [promptSelection, setPromptSelection] = useState(null);
    const [responseDone, setResponseDone] = useState(true);
    const [editChatTitle, setEditChatTitle] = useState(false);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { captureEvent } = usePosthog();
    
    useEffect(() => {
        setCompletions(chatData.length > 0 ? chatData : []) 
        !chatData.length && promptInputRef.current.focus();
        
    }, [chatData])

    useEffect(() => {
       // dispatch(resetTasks());
        document.getElementById('ai-assistant-fullscreen')?.classList?.remove('slide-left');
    }, [id])

    useEffect(() => {
        !fullscreen && dispatch(clearChat({changed: false}));
        promptInputRef.current?.focus();
    }, [])

    useEffect(() => {
        chatContainerRef.current.scrollTop = chatContainerRef.current.scrollHeight;
    }, [completions])

    useEffect(() => {
        personaSelection !== null && dispatch(setCurrentPersona(personaSelection));
    }, [personaSelection])

    useEffect(() => {
        if(persona?.description){
            setCompletions(completions => {
                const c = JSON.parse(JSON.stringify(completions));
                if(c.length > 0){
                    c[0].content = persona.description;
                }
                return c;
            })
        }
    }, [persona])

    useEffect(() => {
        const prompt = promptInputRef.current.value;
        if(prompt.length > 0){
            updateChatContainerHeight((promptInputRef.current.scrollHeight < 90 ? 90 : promptInputRef.current.scrollHeight) + "px")
            promptInputRef.current.focus();
            setFocus(true);
        }else{
            updateChatContainerHeight()
        }
    }, [promptInputRef.current.value])

    useEffect(() => {
        if(promptSelection?.description){
            dispatch(setCurrentPrompt(promptSelection.description));
        }
    }, [promptSelection])
    
    const send = (e, text = null) => {
        e.preventDefault();
        //const prompt = promptInput.current.value;
        let prmt = text //!== null ? text : prompt;

        if(prmt?.length > 0){
            let data = [...completions, {id: `chatgpt-${Date.now()}`, "role": "user", "content": prmt, sender: 'You', created: Math.floor((new Date()).getTime() / 1000)}].filter(t => t.role != 'error');
            promptInputRef.current.value = '';
            updateChatContainerHeight('90px');
            setTimeout(() => {
                promptInputRef.current.focus();
            }, 100)
            dispatch(setCurrentPrompt(''));
            setCompletions(data);
            setProgress(true);
            setResponseDone(false);
            sendPrompt1({id, role: 'user', content: prmt, chatType}).then(async (reader) => {
                while (true) {
                    const {value, done} = await reader.read();
                    if (done) {
                        setResponseDone(true);
                        break;
                    }

                    let prompts = value.match(/\{([^\n]*)/g);
                    if(prompts){
                        prompts.map(pmt => {
                            try{
                                let p = JSON.parse(pmt);
                        
                                if(p.choices[0].finish_reason == 'stop'){
                                    // Get chat title
                                    if(title !==  null){
                                        saveConversation({id, title, conversation: JSON.stringify(data), taskList, chatType, date: moment().startOf('date').toISOString()}).then(response => {
                                            dispatch(setChat({data, title, id: response.data.responseData?.id ?? null, taskList}));
                                        });
                                    }else{
                                        getChatTitle([...(data.map(d => ({role: d.role, content: d.content}))), {role: 'user', content: `Very short title for the following question:
                                        
                                        ${data[1].content}`}]).then(response => {
                                            // Save the chat
                                            const chatTitle = response?.choices?.[0]?.message?.content ?? 'New Chat';
                                            saveConversation({id, title: chatTitle, conversation: JSON.stringify(data), taskList, chatType, date: moment().startOf('date').toISOString()}).then(response => {
                                                dispatch(setChat({data, title: chatTitle, id: response.data.responseData?.id ?? null, taskList}));
                                            });
                                        })
                                    }
                                    
                                    return;
                                }
                                    
                                let index = _.findIndex(data, ["id", p.id]);
                                if(index > -1){
                                    data[index] = {...data[index], content: `${data[index].content}${p.choices[0].delta.content}`, sender: persona?.label, created: p.created} 
                                    setCompletions([...data]);
                                // dispatch(setChat({data, title, id: p.id}));
                                }else{
                                    data.push({id: p.id, role: p.choices[0].delta.role, content: '', sender: persona?.label, created: p.created});
                                    setTimeout(() => setProgress(false), 100)
                                }
                            }catch(e){
                                //console.log('INCOMPLETE: ', e)
                            }
                        })
                    }
                }

                // Capture AI chat started event
                if(!id){
                    captureEvent('AI Chat Started');
                }else{
                    // Capture AI chat continued event
                    captureEvent('AI Chat Continued - Thread ID: ' + id);
                }
            }).catch(e => {
                setResponseDone(true);
                if(e.name == 'AbortError')
                    return;

                //console.log('GPT ERROR:', e);

                data.push({id: `chatgpt-error-${Date.now()}`, prompt: prmt, role: 'error', content: 'Oops! Something went wrong.', sender: persona?.label, created: Math.floor((new Date()).getTime() / 1000)});
                setTimeout(() => setProgress(false), 100);
                const chatTitle = title ?? 'New Chat';
                saveConversation({id, title: chatTitle, conversation: JSON.stringify(data), taskList, chatType, date: moment().startOf('date').toISOString()}).then(response => {
                     dispatch(setChat({data, title: chatTitle, id: response.data.responseData?.id ?? null, taskList}));
                });
            });

            setTimeout(() => {
                document.getElementById('container_aiAssistant')?.scrollIntoView({
                    behavior: 'auto',
                    block: 'center',
                    inline: 'center'
                });
            }, 100)
        }
    }
    function scrollToBottom() {    
        const element = chatContainerRef.current;
        if(!element.classList.contains('dnt-scroll')){
            element.scrollTop = element.scrollHeight;
        }
    }

    const toggleMinMax = (e) => {
        e.preventDefault();

        navigate('/ai-assistant')
    }

    const chatBoxClickHandler = (e) => {
        // const gptContainer = document.querySelector('.gptContainer');
        // if(gptContainer && !gptContainer.classList.contains('mounted')){
        //     gptContainer.classList.add('mounted')
        //     return;
        // }
        // if(e.target.closest('.timeline-li') || e.target.closest('.newChat') || e.target.closest('.chatTextarea') || e.target.closest('.chat-action') || e.target.closest('.cstmGetoption') || e.target.closest('.customSelect__menu__option')){
        //     setFocus(true);
        // }else{
        //     setFocus(false);
        // }
    }

    useEffect(() => {
        const element = chatContainerRef.current;
        element.addEventListener('DOMSubtreeModified', scrollToBottom);
        document.addEventListener('click', chatBoxClickHandler);

        return () => {
            element.removeEventListener('DOMSubtreeModified', scrollToBottom);
            document.removeEventListener('click', chatBoxClickHandler);
        };
    }, []);

    const copyMessageToClipboard = (e, text, id) => {
        e.preventDefault();
        navigator.clipboard.writeText(text);
        chatContainerRef.current.classList.add('dnt-scroll')
        setCopyMessageId(id)
    }

    const removeActivePersona = (e) => {
        dispatch(setCurrentPersona(CHATGPT.PERSONAS[0]));
    }

    const cancel = (e) => {
        e.preventDefault();

        cancelHandler();
    }

    const deleteChat = (e) => {
        e.preventDefault();
        deleteConversation(id).then(result => {
            dispatch(clearChat({changed: false}));
        });
    }

    const editTitle = (e) => {
        e.preventDefault();
        setEditChatTitle(true);

        setTimeout(() => {
            titleInput.current.focus();
        }, 100)
    }

    const saveTitle = (e) => {
        e.preventDefault();
        if(titleInput.current.value.replace(/^\s|\s$/, '').length === 0){
            return false;
        }
        const data = {id: id, title: titleInput.current.value, conversation: JSON.stringify(completions), taskList};
        saveConversation(data).then(response => {
            dispatch(setChat({data: JSON.parse(data.conversation), title: data.title, id: data.id, taskList}));
            setEditChatTitle(false);
        });
    }

    const cancelEditTitle = (e) => {
        e.preventDefault();
        setEditChatTitle(false);
    }

    const updateChatContainerHeight = (promptInputHeight = '90px') => {
        const chatContainer = chatContainerRef.current;
        const promptInputWrapper = promptInputWrapperRef.current;
        const chatTitle = chatTitleRef.current;

        promptInputRef.current.style.height = '90px';
        promptInputRef.current.style.height = promptInputHeight;

        setTimeout(() => {
            if(chatContainer && promptInputWrapper && chatTitle){
                chatContainer.style.height = `calc(100% - ${promptInputWrapper.clientHeight + chatTitle.clientHeight}px)`;
                chatContainer.style.bottom = `${promptInputWrapper.clientHeight}px`;
            }
        }, 100)
    }

    const onCreateTodos = useCallback(() => {
        const content = "Success! All tasks have been created successfully.\n\nLet me know if there's anything else you'd like to do—perhaps updating tasks, or organizing them further?";
        const data = [...completions, {id: `chatgpt-todos-${Date.now()}`, prompt: [{role: 'assistant', content}], role: 'assistant', content, sender: persona?.label, created: Math.floor((new Date()).getTime() / 1000)}];
        setCompletions(data);
        saveConversation({id, title, conversation: JSON.stringify(data)}).then(response => {
            dispatch(setChat({data, title, id: response.data.responseData?.id ?? null, taskList, excludeTaskList: true}));
        });
    }, [completions, taskList]);

    return (
        <>
            <div id="chat-gpt-widget" className="quoteContainer flex items-center justify-center" css={{
                '.darkPrimaryColor, .assistant .prompt-text p': {
                    background: `linear-gradient(rgba(var(--theme-mode-rgb-white-reverse), 0.7), rgba(var(--theme-mode-rgb-white-reverse), 0.7)), var(--accent-color)`,
                    WebkitTextFillColor: 'transparent',
                    WebkitBackgroundClip: 'text !important'
                },
                '.darkErrorColor': {
                    background: `linear-gradient(rgba(var(--theme-mode-rgb-white-reverse), 0.7), rgba(var(--theme-mode-rgb-white-reverse), 0.7)), var(--overDue-color)`,
                    WebkitTextFillColor: 'transparent',
                    WebkitBackgroundClip: 'text !important',
                    fontWeight: 500
                }
            }}>
                <div className={`gptContainer widgetWrapper quoteInner w-full ${completions?.length > 1 ? 'activeChat' : ''} ${focus || prompt?.length > 0 ? 'onActive' : ''} pb-5`}>
                    <div ref={chatTitleRef} className='ctTitle' css={{
                        'a': {
                            'span:hover': {
                                background: `radial-gradient(100% 100% at 0% 100%,rgba(var(--theme-mode-rgb-white), 0.60) 165%,rgba(var(--theme-mode-rgb-white), 0.90) 100%),linear-gradient(0deg,var(--accent-color) 0%,var(--accent-color) 100%), var(--theme-mode-color-white)`,
                                backdropFilter: 'blur(52px)'
                            }
                        }
                    }}>
                        {
                            chatType !== null
                            ?
                            <span className='darkPrimaryColor flex items-center gap-[10px]'>{chatType === 'journal' ? 'Journaling' : <><ChatIcon2 color={`var(--accent-color)`} fill={`var(--accent-color)`} /> AI Assistant - Plan Your Day</>}</span>
                            :
                            <>
                                {
                                    title 
                                    ? 
                                    <MessageIcon color={`var(--accent-color)`} fill={`var(--accent-color)`} />
                                    :
                                    <ChatIcon2 color={`var(--accent-color)`} fill={`var(--accent-color)`} />
                                }
                                
                                {
                                    editChatTitle
                                    ?
                                    <input type="text" ref={titleInput} defaultValue={title} />
                                    :
                                    <span className='darkPrimaryColor'>{title ? title : 'How can I help you?'}</span>
                                }
                                
                                <span className="flex-1 self-stretch"></span>
                                {
                                    editChatTitle
                                    ?
                                    <>
                                        <a href="#" onClick={saveTitle}><span className='icon-round'><Tick /></span></a>
                                        <a href="#" onClick={cancelEditTitle}><span className='icon-round'><Cancel /></span></a>
                                    </>
                                    :
                                    (
                                        fullscreen 
                                        ?
                                        (
                                            title
                                            &&
                                            <>
                                                <a href="#" onClick={deleteChat}><span className='icon-round'><Trash /></span></a>
                                                <a href="#" onClick={editTitle}><span className='icon-round'><EditIcon2 /></span></a>
                                            </>
                                        )
                                        :
                                        <>
                                        {fullscreenButton && <a href="#" onClick={toggleMinMax}><span className='icon-round'><MaximizeIcon /></span></a>}
                                            <a href="#" onClick={cancel}><span className='icon-round'><Cancel /></span></a>
                                        </>
                                    )
                                }
                            </>
                        }  
                    </div>
                    <div ref={chatContainerRef} className='completions-wrapper' id="completion" style={{color: theme== "dark" ? "white" :"black"}}>
                        <div className='main-completion-wrapper'>
                    {
                        completions.map(completion => {
                            return completion.role == "system" 
                            ? 
                            null 
                            : 
                            <>
                                <div key={completion.id} className={`completions ${completion.id} ${completion.role}`}>
                                    {
                                        completion.role != 'error'
                                        &&
                                        (
                                            copyMessageId == completion.id
                                            ?
                                            <a href="#" className='copyMessage button primary' onClick={e => copyMessageToClipboard(e, completion.content, completion.id)} css={{
                                                background: `radial-gradient(100% 100% at 0% 100%,rgba(var(--theme-mode-rgb-white), 0.60) 165%,rgba(var(--theme-mode-rgb-white), 0.90) 100%),linear-gradient(0deg,var(--accent-color) 0%,var(--accent-color) 100%), var(--theme-mode-color-white)`,
                                                backdropFilter: 'blur(52px)'
                                            }}>
                                                <CopyActiveIcon color={`var(--accent-color)`} fill={`var(--accent-color)`} /> <span className='copy'>Copied</span>
                                            </a>
                                            :
                                            <a href="#" className='copyMessage button primary' onClick={e => copyMessageToClipboard(e, completion.content, completion.id)} css={{
                                                'svg:last-of-type':{
                                                    display: 'none'
                                                },
                                                '&:hover': {
                                                    background: `radial-gradient(50% 100% at 50% 100%, rgba(var(--theme-mode-rgb-white), 0.60) 0%, rgba(var(--theme-mode-rgb-white), 0.90) 100%), linear-gradient(0deg, var(--accent-color) 0%, var(--accent-color) 100%), var(--theme-mode-color-white)`,
                                                    backdropFilter: 'blur(52px)',
                                                    'svg:last-of-type':{
                                                        display: 'block'
                                                    },
                                                    'svg:first-child':{
                                                        display: 'none'
                                                    }
                                                }
                                            }}>
                                                <CopyIcon /> 
                                                <CopyActiveIcon id={`copy_id_${completion.id}`} color={`var(--accent-color)`} fill={`var(--accent-color)`} /> 
                                                <span className='copy'>Copy</span>
                                            </a>
                                        )
                                    }
                                    <div className={`prompt-card ${completion.role}`}>
                                        {
                                            completion.role == 'error'
                                            ?
                                            <ChatGPTErrorIcon color={'var(--overDue-color)'} fill={'var(--overDue-color)'} />
                                            :
                                            (
                                                completion.role == 'user'
                                                ?
                                                <ChatUserIcon color={`var(--accent-color)`} fill={`var(--accent-color)`} />
                                                :
                                                <ChatGPTIcon color={`var(--accent-color)`} fill={`var(--accent-color)`} />
                                            )
                                        }
                                        <div className='prompt-text'>
                                            {completion.role !== 'error' && <div className='persona-details text-xs line-height-normal'><span className='accent-text-color'>{completion.sender == 'Default' ? 'Assistant' : completion.sender}</span><span className='time'>{completion.created ? moment(parseInt(completion.created) * 1000).format('LT') : ''}</span></div>}

                                            {
                                                completion.role == 'assistant' 
                                                ? 
                                                <CompletionContent content={completion.content} id={id} />
                                                : 
                                                (completion.role !== 'error' ? completion.content : <span className='darkErrorColor'>{completion.content}</span>)
                                            }

                                            {
                                                completion.role == 'error'
                                                &&
                                                <div><a className='button primary' style={{background: `linear-gradient(0deg, rgba(var(--theme-mode-rgb-white), 0.95) 0%, rgba(var(--theme-mode-rgb-white), 0.95) 100%), var(--accent-color)`}} href="#" onClick={e => send(e, completion.prompt)}><ReloadIcon2 /> Try again</a></div>
                                            }
                                        </div>
                                    </div>
                                </div>
                                <div className="hr-line h-[3.1px] after:!left-0 after:!bottom-0"></div>
                            </>
                        })
                    }
                    {
                    progress && <span className='progress-text darkPrimaryColor'>Generating Response.</span>
                    }
                    
                    </div>
                    </div>
                    {
                        
                    }
                    <PromptInputBox ref={promptInputWrapperRef} promptInputRef={promptInputRef} focus={focus} setFocus={setFocus} send={send} theme={theme} persona={persona} personaRef={personaRef} removeActivePersona={removeActivePersona} responseDone={responseDone} setResponseDone={setResponseDone} updateChatContainerHeight={updateChatContainerHeight} />
                </div>
            </div>
            {
                chatType === null 
                ?
                <TodoList id={id} onCreateTodos={onCreateTodos} />
                :
                (
                    chatType === 'plan-today'
                    ?
                    <PlannedTasks id={id} onCreateTodos={onCreateTodos} />
                    :
                    null
                )
            }
        </>
    )
}

export default Chat